import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/UI/ErrorBoundary';
import { initMixpanel } from './lib/mixpanel';
import './index.css';
import { initPerformanceMetrics } from './lib/performanceMetrics';

initMixpanel();
initPerformanceMetrics();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
